import {
    CLEAR_USER_CONFIG,
    FETCH_USER_CONFIG,
    MODIFY_USER_CONFIG,
    LIST_USER_CONFIG, ERROR_USER_CONFIG
} from "./types";

const init = {
    isLoading: false,
    list: [],
    filter: {},
    page: 1,
    size: 50,
    totals: 0,
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_USER_CONFIG:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_USER_CONFIG:
            return {
                ...state,
                isLoading: false,
                list: payload.data,
                ...payload.paging
            };
        case MODIFY_USER_CONFIG:
            return {
                ...state,
                isLoading: true,
            };
        case CLEAR_USER_CONFIG:
            return {
                ...init
            };
        case ERROR_USER_CONFIG:
            return {
                ...state,
                isLoading: false
            };
        default:
            return state;
    }
}